import { useCallback } from "react";
import { getAllVehicleExpenseStatsAPI } from "services/api/fleet/vehicles/expenses/api";
import VehicleExpenseStats from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleExpenseSearchPage/components/VehicleExpenseStats/VehicleExpenseStats";
import ExpenseSearchFilters from "../ExpenseSearchFilters/ExpenseSearchFilters";
import { ExpenseStatsTabProps } from "./types";

// Tenant-wide stats — reuse-a istog kompozita kao per-vehicle widget. BE
// uvažava iste dimenzije kao i Pretraga tab (vrsta troška, range iznosa, marka /
// model / tip), pa graph odražava točno ono što korisnik filtrira u glavnom
// filter baru. Selling-price overlay nije primjenjiv globalno (BE vraća
// prazan `sellingPriceHistory`); chart se graciozno renderira bez te linije.
const ExpenseStatsTab: React.FC<ExpenseStatsTabProps> = ({ filters, setFilters }) => {
  // useCallback nije sam po sebi dovoljan — Monthly/Weekly imaju fetchStats u
  // useEffect deps, pa moramo proizvesti novu referencu KAD se filteri mijenjaju
  // (refetch) i istu KAD se ne mijenjaju (no-op render).
  const fetchStats = useCallback(
    () =>
      getAllVehicleExpenseStatsAPI({
        expenseTypeId: filters.expenseTypeId,
        amountMin: filters.amountMin,
        amountMax: filters.amountMax,
        vehicleManufacturerId: filters.vehicleManufacturerId,
        vehicleModelId: filters.vehicleModelId,
        vehicleTypeId: filters.vehicleTypeId,
      }),
    [
      filters.expenseTypeId,
      filters.amountMin,
      filters.amountMax,
      filters.vehicleManufacturerId,
      filters.vehicleModelId,
      filters.vehicleTypeId,
    ]
  );

  return (
    <div className="px-0 py-6 mx-[-1px] xl:px-6">
      <ExpenseSearchFilters formValues={filters} setFormValues={setFilters} />
      <VehicleExpenseStats
        fetchStats={fetchStats}
        title="Troškovi flote"
        subtitle="Kumulativni pregled svih vozila"
      />
    </div>
  );
};

export default ExpenseStatsTab;
